/**
 * Transforma un modelo string "miObjeto.miCampo" en array "['miObjeto', 'miCampo']"
 * Admite notación con brackets, ej. "miObjeto['miCampo']"
 * Admite arrays, ej. "miObjeto.miArray[0]" -> ['miObjeto', 'miArray[0]']
 *
 * Ojo que los array "arr[42]" podría transformarlos en 'arr', '42'
 * pero no se hace porque se pierde el saber que es un array.
 * -> ver `tokenizer` para eso.
 * Se necesita saber para el setValueToScope para inicializar a `array` los array undefined
 *
 * > Diferencias entre `modelSplitter` y `tokenizer`
 * > modelSplitter('CAB.LIN[0]') // -> ['CAB', 'LIN[0]']
 * > tokenizer('CAB.LIN[0]') // -> ['CAB', 'LIN', '0']
 *
 *
 * @param {string} model el modelo
 * @returns {array}
 */
export function modelSplitter(model = '') {
  const tokens = model.match(/\[.[ \wÀ-ÿ]+.\]\[[\d]*\]|[ \wÀ-ÿ]+\[[\d]*\]|[ \wÀ-ÿ]+/g) || []; // 1. | 2. | 3.
  return tokens.map(exp => {
    // transformamos los sobrantes "['LIN'][10]" en "LIN[10]"
    return exp.match(/[ \wÀ-ÿ]+|\[[\d]*\]/g).join(''); // 4. | 5.
  });
}

/* 

Explicaciones sobre cada regex

1. detectamos los "['LIN'][10]"
2. o detectamos los "LIN[10]"
3. o detectamos los "LIN"
4. detectamos los "LIN" dentro de "['LIN']"
5. o detectamos los "[10]"

para mas detalle, copiar las regex en el https://regex101.com/ que da explicaciones detalladas

*/
